module.exports = __webpack_public_path__ + "static/media/code_to_compete_2024.fbaac72d.jpeg";